import React from 'react'

export default function InviteRevoked(props) {
    // it's harsh to say "revoked", so saying "expired" as per Chris's request
    return (<h1 style={{textAlign: 'center'}}>This invite has expired</h1>)
}
